<template>
    <div :class="classComputed">{{state}}</div>
</template>

<style lang="less">
    @import '../assets/less/components/post-state.less';
</style>

<script>
import SelectOptions from '../store/topicContent/state/constants';
export default {
    props: {
        postState: {
            'type': String,
            'value': ''
        }
    },
    computed: {
        state() {
            return SelectOptions.postStateMap[this.postState];
        },
        classComputed() {
            let toLowerCase = this.postState.toLowerCase();
            return `f-list-${toLowerCase}` ;
        }
    },

};
</script>